import { Controller } from '@hotwired/stimulus'
import { ApiService } from '../../../services/apiService'

// Connects to data-controller="utils--form--autosave"
export default class extends Controller {
  static targets = ['status']
  static values = {
    url: String,
    savingText: String,
    savedText: String,
    errorText: String,
    submissionMode: { type: String, default: 'draft' },
    delay: { type: Number, default: 1500 },
  }

  connect() {
    this._inputHandler = () => this.#schedule()
    this._submitHandler = () => this.cancel()
    this.element.addEventListener('input', this._inputHandler)
    this.element.addEventListener('change', this._inputHandler)
    this.element.addEventListener('submit', this._submitHandler)
  }

  disconnect() {
    clearTimeout(this._debounceTimer)
    clearTimeout(this._statusTimer)
    this.element.removeEventListener('input', this._inputHandler)
    this.element.removeEventListener('change', this._inputHandler)
    this.element.removeEventListener('submit', this._submitHandler)
  }

  cancel() {
    clearTimeout(this._debounceTimer)
  }

  #schedule() {
    if (this.element.querySelector('fieldset')?.disabled) return
    clearTimeout(this._debounceTimer)
    this.#setStatus('saving')
    this._debounceTimer = setTimeout(() => this.#save(), this.delayValue)
  }

  async #save() {
    if (this._saving) return
    this._saving = true

    const formData = new FormData(this.element)
    formData.set('submission_mode', this.submissionModeValue)
    const { param, token } = ApiService.getCSRFConfig()
    formData.set(param, token)

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        credentials: 'same-origin',
        // No Content-Type header — browser sets multipart/form-data with boundary automatically
        headers: { Accept: 'application/json' },
        body: formData,
      })
      this.#setStatus(response.ok ? 'saved' : 'error')
    } catch {
      this.#setStatus('error')
    } finally {
      this._saving = false
    }
  }

  #setStatus(state) {
    if (!this.hasStatusTarget) return
    clearTimeout(this._statusTimer)

    const messages = {
      saving: this.savingTextValue,
      saved: this.savedTextValue,
      error: this.errorTextValue,
    }
    this.statusTarget.textContent = messages[state] || ''
    this.statusTarget.dataset.state = state

    if (state === 'saved') {
      this._statusTimer = setTimeout(() => {
        if (this.statusTarget.dataset.state === 'saved') {
          this.statusTarget.textContent = ''
        }
      }, 3000)
    }
  }
}
